module.exports = __webpack_public_path__ + "media/enter.eccb272a.wav";